import {
  ImpressionEvent,
  ScreenViewEvent,
  SearchEvent,
  SelectContentEvent,
  SelectItemEvent,
  ViewGalleryResultsEvent,
  ViewItemListEvent,
} from '@moonpig/launchpad-analytics'

export const screenViewEvent = () =>
  ScreenViewEvent()
    .withApplicationData({ datalayer_version: 1 })
    .withScreenData({ render_type: 'client' })

export const searchEvent = () =>
  SearchEvent().withEventData({
    category: 'search',
    action: 'run search',
    non_interaction: true,
  })

export const collectionResultsEvent = () =>
  ViewGalleryResultsEvent().withEventData({
    category: 'collection',
    action: 'view collection results',
    non_interaction: true,
  })

export const viewItemListEvent = () =>
  ViewItemListEvent().withEventData({
    category: 'product action',
    action: 'view item list',
    non_interaction: true,
  })

export const departmentEvent = () =>
  SelectContentEvent().withEventData({
    category: 'search',
    action: 'global header click',
    non_interaction: true,
  })

export const filtersMenuEvent = () =>
  SelectContentEvent().withEventData({
    non_interaction: true,
  })
export const filterCategoryEvent = () =>
  SelectContentEvent().withEventData({
    non_interaction: true,
  })
export const clearFiltersEvent = () =>
  SelectContentEvent().withEventData({
    action: 'clear filters',
    non_interaction: true,
  })
export const sortByEvent = () =>
  SelectContentEvent().withEventData({
    action: 'sort by',
    non_interaction: true,
  })
export const navigatePagesEvent = () =>
  SelectContentEvent().withEventData({
    action: 'navigate pages',
    non_interaction: true,
  })
export const milestoneResultsEvent = () =>
  SelectContentEvent().withEventData({
    action: 'show milestone results',
    non_interaction: true,
  })
export const zeroResultsEvent = () =>
  ImpressionEvent().withEventData({
    action: 'zero results viewed',
  })

export const breadcrumbEvent = () =>
  SelectContentEvent().withEventData({
    category: 'site breadcrumb selection',
    action: 'global navigation link click',
    non_interaction: true,
  })

export const scrollToTopEvent = () =>
  SelectContentEvent()
    .withEventData({
      category: 'navigation',
      action: 'utility links',
      label: 'jump to top',
      non_interaction: true,
    })
    .withContentData({
      content_type: 'navigation | utility links | jump to top',
    })

export const contactUsEvent = () =>
  SelectContentEvent().withEventData({
    category: 'search',
    action: 'button clicked',
    non_interaction: true,
  })
export const contactUsImpressionEvent = () =>
  ImpressionEvent().withEventData({
    category: 'search',
    action: 'view',
    non_interaction: true,
  })

export const multiBuyEvent = () =>
  SelectContentEvent().withEventData({
    category: 'multibuy list',
    label: 'multibuy list entry point toggle',
    non_interaction: true,
  })

export const closeAgeBannerEvent = () =>
  SelectContentEvent().withEventData({
    category: 'close age banner',
    label: 'age selection entry point banner',
    non_interaction: true,
  })

export const recentlyViewedEvent = () =>
  SelectContentEvent().withEventData({
    category: 'product action',
    action: 'list click',
    non_interaction: true,
  })
export const selectRecentlyViewedEvent = () =>
  SelectItemEvent().withEventData({
    category: 'product action',
    action: 'select item',
    non_interaction: true,
  })

export const viewSearchItemsEvent = () =>
  viewItemListEvent().withEventData({
    category: 'search',
    action: 'view search results',
  })
export const viewCollectionItemsEvent = () =>
  viewItemListEvent().withEventData({
    category: 'collection',
    action: 'view collection results',
  })
export const viewGalleryItemsEvent = () =>
  viewItemListEvent().withEventData({
    category: 'gallery',
    action: 'view gallery results',
  })

export const shoppingListImpressionEvent = () =>
  ImpressionEvent().withEventData({
    category: 'multibuy list',
    action: 'view multibuy list',
  })
export const shoppingListToggleEvent = () =>
  SelectContentEvent().withEventData({
    category: 'multibuy list',
    non_interaction: true,
  })
export const shoppingListRemoveEvent = () =>
  SelectContentEvent()
    .withEventData({
      category: 'multibuy list',
      action: 'removed',
      label: 'multibuy list remove button',
      non_interaction: true,
    })
    .withContentData({
      content_type: 'multibuy list | removed | multibuy list remove button',
    })
